export enum ToolbarDirection {
  PREV_PERIOD = -1,
  TODAY = 0,
  NEXT_PERIOD = 1
}